import {Component, Input} from "@angular/core";
import {ProgressBarData, ProgressBarStatus} from "./progressbar.interface";
import {LabelFn, LabelSettings} from "@progress/kendo-angular-progressbar";
import {TranslateService} from "../translate";

@Component({
	selector: "cp-progressbar",
	templateUrl: 'progressbar.template.html',
	styleUrls: ['progressbar.style.scss']
})
export class ProgressbarComponent {
	@Input() data: ProgressBarData;
	@Input() status: ProgressBarStatus;

	private readonly progressBarLabelSettings: LabelSettings[];

	constructor(private translateService: TranslateService) {
		this.progressBarLabelSettings = [
			{
				visible: true,
				position: 'start',
				format: () => 'Processing'
			},
			{
				visible: true,
				position: 'start',
				format: this.numFormatter
			},
			{
				visible: true,
				position: 'center',
				format: () => <string>this.translateService.instant('PurgePatient.ProgressBar.Error.Message')
			},
			{
				visible: true,
				position: 'center',
				format: () => <string>this.translateService.instant('PurgePatient.ProgressBar.Success.Message')
			}
		];
	}

	get value(): number {
		return this.data && this.data.processed ? this.toPercentage(this.data.processed, this.data.total) : 0;
	}

	get indeterminate(): boolean {
		return this.status === ProgressBarStatus.pending;
	}

	get labelSettings(): LabelSettings {
		return this.progressBarLabelSettings[this.status];
	}

	get progressCssClass(): string {
		if (this.status == ProgressBarStatus.failed) {
			return 'error';
		}
		if (this.status == ProgressBarStatus.completed) {
			return 'success';
		}
		return '';
	}

	private toPercentage(value: number, total: number): number {
		return ~~(value / total * 100);
	}

	public numFormatter: LabelFn = (value: number): string => {
		return this.data && this.data.total ? `${value}/${this.data.total}` : '0/0';
	};

}
